/**
 * @class
 */
import Base from './assetConstituent';

export default class AssetConstituent_Layer extends Base {
	/**
	 * @property {object}  defaults       - The default attribute values
	 * @property {number}  defaults.type  - Default type (2 = layer)
	 */
	get defaults() {
		return _.extend(super.defaults, {
			type: 2,
		});
	}

	/** @type {string} */
	static get __name__() {
		return 'AssetConstituent_Layer';
	}
}
